module.exports = __webpack_public_path__ + "static/neufile-grotesk-bold-a28ebfa66d38d55e9023258cfe0d2bd0.woff";